import React, { useEffect, useRef, useState } from 'react'
import Spline from '@splinetool/react-spline';
import anadaIcon from '../assets/images/home/aanand-icon.png'
import cubeIcon from '../assets/images/home/cube-icon.png'
import walletIcon from '../assets/images/home/wallet__icon.png'
import commingSoonTag from '../assets/images/home/coming-soon-tag.png'
import placeCardIcon from '../assets/images/home/placard__icon.png'
import sortIcon from '../assets/images/home/sort.png'
// import tokenChart from '../assets/images/home/token-chart.png'
// import digital1 from '../assets/images/home/digital-1.png'
// import digital2 from '../assets/images/home/digital-2.png'
// import digital3 from '../assets/images/home/digital-3.png'
// import copyIcon from '../assets/images/home/copy_icon.png'
import globalMarket from '../assets/images/home/global-market.png'
import nowBlogs from '../assets/images/home/nowblog-icon.svg'
import nowWallet from '../assets/images/home/nowwallet-icon.svg'
import nowTracker from '../assets/images/home/nowtracker-icon.svg'


import emailIcon from '../assets/images/home/email-blue_icon.svg'
import locationIcon from '../assets/images/home/location-blue_icon.svg'
import featureIntegratedPlatform from '../assets/images/home/feature_integrated_platform.png'
import featureSecurePayments from '../assets/images/home/feature_secure_payments.png'
import featureRobustArchitecture from '../assets/images/home/feature_robust_architecture.png'

import NewHeader from '../components/NewHeader';
import NewFooter from '../components/NewFooter'
import '../assets/styles/home.css'
import { useTranslation } from 'react-i18next'
import { NetworkList } from '../utils/networkList'
import { truncateNumber } from '../utils/helper'
import AboutToken from '../components/AboutToken'
import Notify from '../components/notification'


const ContactUs = () => {
    const { t } = useTranslation();
    const formRef = useRef(null);

    // Controlled input state
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });

    // Handle input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Submitted Data:", formData);

        // Show notification
        Notify("Data submitted successfully.", "success");

        // Reset form state
        setFormData({ name: "", email: "", subject: "", message: "" });

        // Reset using ref (optional)
        if (formRef.current) {
            formRef.current.reset();
        }
    };

    return (
        <section className="get__touch__section">
            <div className="container">
                <div className="row">
                    {/* Contact Details */}
                    <div className="col-md-6">
                        <div className="get__in__touch__content">
                            <h3>{t("contactUs.title")}</h3>
                            <p>{t("contactUs.description")}</p>

                            <div className="get__in__touch__email__bx">
                                <div className="get__email__bx">
                                    <img src={emailIcon} alt="Email" />
                                    <div className="email__bx">
                                        <h6>{t("contactUs.email")}</h6>
                                        <a href="mailto:info@aanands.com">info@aanands.com</a>
                                    </div>
                                </div>
                                <div className="get__email__bx">
                                    <img src={locationIcon} alt="Location" />
                                    <div className="email__bx">
                                        <h6>{t("contactUs.location")}</h6>
                                        <a href="#">{t("contactUs.seoul")}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <div className="col-md-6">
                        <div className="form__footer__bx">
                            <form ref={formRef} onSubmit={handleSubmit} className="cust_-footer__form">
                                <div className="mb-3">
                                    <label htmlFor="Name" className="form-label">{t("contactUs.name")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="Email" className="form-label">{t("contactUs.email")}</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="Email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="Subject" className="form-label">{t("contactUs.subject")}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="Subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="Message" className="form-label">{t("contactUs.message")}</label>
                                    <textarea
                                        className="form-control"
                                        id="Message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        rows="3"
                                        required
                                    ></textarea>
                                </div>
                                <div className="mb-3">
                                    <button type="submit" className="btn btn__submit__frm">
                                        {t("contactUs.submit")}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};



const HomeBanner = () => {
    const { t } = useTranslation();
    return (
        <div className="container mx-auto pt-32 lg:pt-40 pb-12 mb-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center w-full">
                <div className="flex flex-col gap-8">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/10 border border-brand-gold/20 w-fit">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-gold"></span>
                        </span>
                        <span className="text-brand-gold text-xs font-bold uppercase tracking-widest">{t("homeBanner.limited_offer")}</span>
                    </div>
                    <h1 className="text-slate-100 text-5xl md:text-7xl font-bold leading-[1.1] tracking-tight">
                        {t("homeBanner.title")}
                    </h1>
                    <p className="text-slate-400 text-lg md:text-xl leading-relaxed max-w-lg">
                        {t("homeBanner.description")}
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <a href="/buy-and" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center min-w-[180px] h-14 bg-brand-gold text-background-dark rounded-xl font-bold text-lg hover:brightness-110 transition-all gold-glow">
                            {t("homeBanner.buy_and")}
                        </a>
                    </div>
                </div>
                {/* 3D Element Showcase */}
                <div className="relative flex items-center justify-center">
                    <div className="absolute inset-0 bg-brand-gold/20 blur-[100px] rounded-full"></div>
                    <div className="relative w-full max-w-md aspect-square flex items-center justify-center">
                        <div className="w-full h-full relative overflow-visible flex items-center justify-center">
                            <div className="pointer-events-none w-[1200px] h-[1200px] absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 scale-[0.55] md:scale-[0.65]" style={{ clipPath: 'inset(0px 0px 80px 0px)' }}>
                                <Spline scene="https://prod.spline.design/1pyp0RLlAoUIGUGH/scene.splinecode" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};


// const SwapCrypto = () => {

//     const [selectedFromCrypto, setFromSelectedCrypto] = useState({
//         name: "Avalanche",
//         icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/avax.svg"
//     });

//     const cryptoOptions = [
//         { name: "Avalanche", icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/avax.svg" },
//         { name: "Bitcoin", icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/btc.svg" },
//         { name: "Ethereum", icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/eth.svg" },
//         { name: "Tron", icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/trx.svg" },
//         { name: "Tether", icon: "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@bea1a9722a8c63169dcc06e86182bf2c55a76bbc/svg/color/usdt.svg" }
//     ];

//     return (
//         <div className="tab-content p-3 border bg-light" id="nav-tabContent">
//             <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab ">
//                 <div className="you__send__bx__frm mb-0">
//                     <div className="from__txt__bx">
//                         <p>From</p>
//                         <div className="select__bx">
//                             <div className="dropdown cust__drp__coin">
//                                 <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
//                                     {selectedFromCrypto.name}
//                                 </button>
//                                 <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
//                                     {cryptoOptions.map((crypto, index) => (
//                                         <li key={index}>
//                                             <button
//                                                 className="dropdown-item"
//                                                 onClick={() => setFromSelectedCrypto(crypto)}
//                                             >
//                                                 <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
//                                                 {crypto.name}
//                                             </button>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="d-flex">
//                         <div className="select__bx">
//                             <div className="dropdown cust__drp__coin">
//                                 <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
//                                     WETH
//                                 </button>
//                                 <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
//                                     {cryptoOptions.map((crypto, index) => (
//                                         <li key={index}>
//                                             <button
//                                                 className="dropdown-item"
//                                                 onClick={() => setFromSelectedCrypto(crypto)}
//                                             >
//                                                 <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
//                                                 {crypto.name}
//                                             </button>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                         <div className="txt__field__bx">
//                             <input type="text" className="form-control bg-transparent border-0 color__white text-end p-0" placeholder="0.01" value="0.01" />
//                         </div>

//                     </div>
//                     <div className="max__bx__container">
//                         <p className="max__txt__swap">Max</p>
//                         <p className="max__amount__txt">$2611.20 </p>
//                     </div>
//                 </div>
//                 <div className="swap__icon__bx">
//                     <img src={sortIcon} alt="" />
//                 </div>
//                 <div className="you__send__bx__frm">
//                     <div className="from__txt__bx">
//                         <p>To</p>
//                         <div className="select__bx">
//                             <div className="dropdown cust__drp__coin">
//                                 <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
//                                     BNB Chain
//                                 </button>
//                                 <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
//                                     {cryptoOptions.map((crypto, index) => (
//                                         <li key={index}>
//                                             <button
//                                                 className="dropdown-item"
//                                                 onClick={() => setFromSelectedCrypto(crypto)}
//                                             >
//                                                 <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
//                                                 {crypto.name}
//                                             </button>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="d-flex">
//                         <div className="select__bx">
//                             <div className="dropdown cust__drp__coin">
//                                 <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
//                                     USDT
//                                 </button>
//                                 <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
//                                     {cryptoOptions.map((crypto, index) => (
//                                         <li key={index}>
//                                             <button
//                                                 className="dropdown-item"
//                                                 onClick={() => setFromSelectedCrypto(crypto)}
//                                             >
//                                                 <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
//                                                 {crypto.name}
//                                             </button>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                         <div className="txt__field__bx">
//                             <input type="text" className="form-control bg-transparent border-0 color__white text-end p-0" placeholder="2610.39" value="2610.39" />
//                         </div>

//                     </div>
//                     <div className="max__bx__container">
//                         <p className="max__txt__swap">Max</p>
//                         <p className="max__amount__txt">$2611.39 </p>
//                     </div>
//                     <div className="add__rec__add__btn__bx">
//                         <button className="btn btn__addrecepient__add">Add recipient address</button>
//                     </div>
//                 </div>
//                 <div className="from__txt__bx">
//                     <p>1 WETH.e = 0.00000 USDTH($-)</p>
//                     <p>FEE:- </p>
//                 </div>
//                 <div className="btn__swap__bx__container">
//                     <button className="btn btn__swap__bx">Swap</button>
//                 </div>
//             </div>
//         </div>
//     )
// }
const SwapCrypto = () => {
    const { t } = useTranslation();
    const [selectedFromCrypto, setSelectedFromCrypto] = useState(NetworkList?.[0]);
    const [selectedToCrypto, setSelectedToCrypto] = useState(NetworkList?.[1]);
    const [selectedFromToken, setSelectedFromToken] = useState(selectedFromCrypto?.tokenList?.[0]);
    const [selectedToToken, setSelectedToToken] = useState(selectedToCrypto?.tokenList?.[0]);
    const [fromTokenAmount, setFromTokenAmount] = useState('');
    const [fromUsdAmount, setFromUsdAmount] = useState(0);
    const [toTokenAmount, setToTokenAmount] = useState('');
    const [toUsdAmount, setToUsdAmount] = useState(0);

    const cryptoOptions = NetworkList

    // Handlers for dropdown selections
    const handleFromCryptoChange = (crypto) => {
        setSelectedFromCrypto(crypto);
    };

    const handleToCryptoChange = (crypto) => {
        setSelectedToCrypto(crypto);
    };

    const handleFromTokenChange = (token) => {
        setSelectedFromToken(token);
    };

    const handleToTokenChange = (token) => {
        setSelectedToToken(token);
    };


    return (
        <div className="lg:col-span-1 glass-morphism p-6 rounded-3xl flex flex-col gap-6 mb-12 relative z-10 w-full">
            <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">{t("swapSection.title")}</h3>
                <span className="material-symbols-outlined text-slate-400 cursor-pointer hover:text-brand-gold">settings</span>
            </div>
            <div className="space-y-4 relative">
                <div className="bg-white/5 rounded-2xl p-4 border border-white/5 focus-within:border-brand-gold/50 transition-colors">
                    <div className="flex justify-between text-xs text-slate-400 mb-2">
                        <span>{t("swapSection.sell")}</span>
                        <span>Balance: 1.24 {selectedFromToken?.tokenSymbol}</span>
                    </div>
                    <div className="flex justify-between items-center gap-4">
                        <input className="bg-transparent border-none focus:ring-0 p-0 text-2xl font-bold text-white w-full placeholder:text-white/20" placeholder="0.0" type="number" value={fromTokenAmount} onChange={(e) => setFromTokenAmount(e.target.value)} />
                        <button className="flex items-center gap-2 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-xl border border-white/10">
                            <span className="font-bold">{selectedFromToken?.tokenSymbol}</span>
                            <span className="material-symbols-outlined text-sm">expand_more</span>
                        </button>
                    </div>
                </div>
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                    <button className="size-10 bg-brand-gold rounded-xl flex items-center justify-center text-background-dark border-4 border-[#12110a] hover:scale-110 transition-transform">
                        <span className="material-symbols-outlined font-bold">swap_vert</span>
                    </button>
                </div>
                <div className="bg-white/5 rounded-2xl p-4 border border-white/5 focus-within:border-brand-gold/50 transition-colors">
                    <div className="flex justify-between text-xs text-slate-400 mb-2">
                        <span>{t("swapSection.buy")}</span>
                        <span>Balance: 0.00 {selectedToToken?.tokenSymbol}</span>
                    </div>
                    <div className="flex justify-between items-center gap-4">
                        <input className="bg-transparent border-none focus:ring-0 p-0 text-2xl font-bold text-white w-full placeholder:text-white/20" placeholder="0.0" type="number" value={toTokenAmount} onChange={(e) => setToTokenAmount(e.target.value)} />
                        <button className="flex items-center gap-2 bg-brand-gold/20 hover:bg-brand-gold/30 px-3 py-1.5 rounded-xl border border-brand-gold/30">
                            <span className="font-bold text-brand-gold">{selectedToToken?.tokenSymbol}</span>
                            <span className="material-symbols-outlined text-sm text-brand-gold">expand_more</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className="p-4 rounded-xl bg-brand-gold/5 border border-brand-gold/10 space-y-2 mt-4">
                <div className="flex justify-between text-xs">
                    <span className="text-slate-400">Exchange Rate</span>
                    <span className="text-slate-200">1 {selectedFromToken?.tokenSymbol} = 2,450.21 {selectedToToken?.tokenSymbol}</span>
                </div>
                <div className="flex justify-between text-xs">
                    <span className="text-slate-400">Slippage Tolerance</span>
                    <span className="text-brand-gold">0.5%</span>
                </div>
            </div>
            <button className="w-full h-14 bg-brand-gold text-background-dark rounded-xl font-bold text-lg hover:brightness-110 transition-all mt-4">
                {t("swapSection.swap")}
            </button>
        </div>
    )
}

const BuyAnd = () => {
    const [selectedFromCrypto, setSelectedFromCrypto] = useState(NetworkList?.[0]);

    const [selectedToCrypto, setSelectedToCrypto] = useState(NetworkList?.[1]);

    const [selectedFromToken, setSelectedFromToken] = useState(selectedFromCrypto?.tokenList?.[0]);
    const [selectedToToken, setSelectedToToken] = useState(selectedToCrypto?.tokenList?.[0]);
    const [fromTokenAmount, setFromTokenAmount] = useState('');
    const [fromUsdAmount, setFromUsdAmount] = useState(0);
    const [toTokenAmount, setToTokenAmount] = useState('');
    const [toUsdAmount, setToUsdAmount] = useState(0);

    const cryptoOptions = NetworkList

    // Handlers for dropdown selections
    const handleFromCryptoChange = (crypto) => {
        console.log("🚀 ~ handleFromCryptoChange ~ crypto:", crypto)
        setSelectedFromCrypto(crypto);
    };

    const handleToCryptoChange = (crypto) => {
        setSelectedToCrypto(crypto);
    };

    const handleFromTokenChange = (token) => {
        setSelectedFromToken(token);
    };

    const handleToTokenChange = (token) => {
        setSelectedToToken(token);
    };


    return (
        <div className="tab-content p-3 border bg-light" id="nav-tabContent">
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab ">
                {/* From Section */}
                <div className="you__send__bx__frm mb-0">
                    <div className="from__txt__bx">
                        <p>From</p>
                        <div className="select__bx">
                            <div className="dropdown cust__drp__coin">
                                <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedFromCrypto.name}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
                                    {cryptoOptions.map((crypto, index) => (
                                        <li key={index}>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleFromCryptoChange(crypto)}
                                            >
                                                <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
                                                {crypto.name}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="select__bx">
                            <div className="dropdown cust__drp__coin">
                                <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedFromToken?.tokenSymbol}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
                                    {selectedFromCrypto?.tokenList?.map((crypto, index) => (
                                        <li key={index}>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleFromTokenChange(crypto)}
                                            >
                                                <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
                                                {crypto.tokenSymbol}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="txt__field__bx">
                            <input type="text" className="form-control bg-transparent border-0 color__white text-end p-0 " autoComplete="off" placeholder="0.01" onChange={(event) => setFromTokenAmount(event.target.value)} value={fromTokenAmount || ''} />
                        </div>

                    </div>
                    <div className="max__bx__container">
                        <p className="max__txt__swap">Max</p>
                        <p className="max__amount__txt">${truncateNumber(fromUsdAmount)} </p>
                    </div>
                </div>

                {/* Swap Icon */}
                <div className="swap__icon__bx">
                    <img src={sortIcon} alt="" />
                </div>

                {/* To Section */}
                <div className="you__send__bx__frm">
                    <div className="from__txt__bx">
                        <p>To</p>
                        <div className="select__bx">
                            <div className="dropdown cust__drp__coin">
                                <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedToCrypto.name}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
                                    {cryptoOptions?.map((crypto, index) => (
                                        <li key={index}>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleToCryptoChange(crypto)}
                                            >
                                                <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
                                                {crypto.name}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="select__bx">
                            <div className="dropdown cust__drp__coin">
                                <button className="btn btn-trasprant dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedToToken?.tokenSymbol}
                                </button>
                                <ul className="dropdown-menu dropdown-menu-dark" aria-labelledby="dropdownMenuButton">
                                    {selectedToCrypto?.tokenList?.map((crypto, index) => (
                                        <li key={index}>
                                            <button
                                                className="dropdown-item"
                                                onClick={() => handleToTokenChange(crypto)}
                                            >
                                                <img className="crypto-icon me-2" src={crypto.icon} alt={crypto.name} width="20" />
                                                {crypto.tokenSymbol}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="txt__field__bx">
                            <input type="text" className="form-control bg-transparent border-0 color__white text-end p-0" placeholder="0.00" value={toTokenAmount} />
                        </div>

                    </div>
                    <div className="max__bx__container">
                        <p className="max__txt__swap">Max</p>
                        <p className="max__amount__txt">${truncateNumber(toUsdAmount)} </p>
                    </div>
                    <div className="add__rec__add__btn__bx">
                        <input className="btn btn__addrecepient__add" placeholder='Add recipient address' />
                    </div>
                </div>
                <div className="from__txt__bx">
                    <p>1 WETH.e = 0.00000 USDTH($-)</p>
                    <p>FEE:- </p>
                </div>
                <div className="btn__swap__bx__container">
                    <button className="btn btn__swap__bx">Swap</button>
                </div>
            </div>
        </div>
    )
}

const SwapSection = () => {
    const [selectedTab, setSelectedTab] = useState('swap');
    const { t } = useTranslation();

    return (
        <section className="swap__section">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <div className="digital__effert__head">
                            <h3>{t("swapSection.title")}</h3>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="swap__container__frm__bx">
                            <nav>
                                <div className="nav nav-tabs mb-3" role="tablist">
                                    <button
                                        className={`nav-link ${selectedTab === 'swap' ? 'active' : ''}`}
                                        onClick={() => setSelectedTab('swap')}
                                        type="button"
                                        role="tab"
                                        aria-selected={selectedTab === 'swap'}
                                    >
                                        Swap Crypto
                                    </button>

                                    <button
                                        className={`nav-link ${selectedTab === 'buy' ? 'active' : ''}`}
                                        onClick={() => setSelectedTab('buy')}
                                        type="button"
                                        role="tab"
                                        aria-selected={selectedTab === 'buy'}
                                    >
                                        Buy AND
                                    </button>
                                </div>
                            </nav>

                            {selectedTab === 'swap' ? <SwapCrypto /> : <BuyAnd />}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

// const AboutToken = () => {
//     const { t } = useTranslation();

//     return (
//         <section className="token__section">
//             <div className="container">
//                 <div className="row mb-5">
//                     <div className="col-md-5">
//                         <div className="token__image__bx">
//                             <img className="w-100" src={tokenChart} alt="Token Chart" />
//                         </div>
//                     </div>
//                     <div className="col-md-7">
//                         <div className="token__table__container">
//                             <h3 className="mb-3">{t("aboutToken.title")}</h3>
//                             <div className="token__text__name">
//                                 <p>{t("aboutToken.tokenName")} :</p>
//                                 <h6>AANAND</h6>
//                             </div>
//                             <div className="token__text__name">
//                                 <p>{t("aboutToken.symbol")} :</p>
//                                 <h6>AND</h6>
//                             </div>
//                             <div className="token__text__name">
//                                 <p>{t("aboutToken.protocol")} :</p>
//                                 <h6>ERC20</h6>
//                             </div>
//                             <div className="token__text__name">
//                                 <p>{t("aboutToken.totalSupply")} :</p>
//                                 <h6>1,000,000,000 AND</h6>
//                             </div>
//                             <div className="token__text__name">
//                                 <p>{t("aboutToken.type")} :</p>
//                                 <h6>{t("aboutToken.utilityToken")}</h6>
//                             </div>
//                             <div className="token__copy__bx">
//                                 <p>{t("aboutToken.contract")}: 0x1b4A74e55b9C...3991E08BFb42f829
//                                     <button className="btn">
//                                         <img src={copyIcon} alt="copy" />
//                                     </button>
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };


const ProjectSection = () => {
    const { t } = useTranslation();

    return (
        <section className="project_prob_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 relative flex items-center justify-center min-h-[500px]">
                        <div className="problem__project__head flex flex-col w-full h-full justify-center z-10 relative">
                            <h2>{t("projectSection.title")}</h2>

                            {/* Unconstrained Spline Container: A massive centered canvas scaled down prevents the 3D model from ever hitting the boundaries and cutting off */}
                            <div className="w-full mt-4 flex items-center justify-center relative pointer-events-none min-h-[450px] overflow-visible">
                                <div className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] scale-[0.45] sm:scale-[0.55] lg:scale-[0.65]" style={{ clipPath: 'inset(0px 0px 80px 0px)' }}>
                                    <Spline scene="https://prod.spline.design/Gps7hqSo7tX4DHum/scene.splinecode" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 d-flex flex-col justify-center">
                        <div className="problem__proj__solved__bx">
                            <p className="icon">+</p>
                            <h6>{t("projectSection.globalKpop.title")}</h6>
                            <p>{t("projectSection.globalKpop.description")}</p>
                        </div>
                        <div className="problem__proj__solved__bx">
                            <p className="icon">+</p>
                            <h6>{t("projectSection.andProject.title")}</h6>
                            <p>{t("projectSection.andProject.description")}</p>
                        </div>
                        <div className="problem__proj__solved__bx">
                            <p className="icon">+</p>
                            <h6>{t("projectSection.connectingFandoms.title")}</h6>
                            <p>{t("projectSection.connectingFandoms.description")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

const PlatformFeatures = () => {
    const { t } = useTranslation();

    return (
        <div className="container mx-auto mt-24 mb-16 px-6 lg:px-0">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 w-full">
                <div className="flex flex-col gap-4">
                    <span className="material-symbols-outlined text-brand-gold text-4xl">security</span>
                    <h4 className="text-xl font-bold text-white">{t("platformFeatures.features.corePlatform.title")}</h4>
                    <p className="text-slate-400">{t("platformFeatures.features.corePlatform.description")}</p>
                </div>
                <div className="flex flex-col gap-4">
                    <span className="material-symbols-outlined text-brand-gold text-4xl">auto_awesome</span>
                    <h4 className="text-xl font-bold text-white">{t("platformFeatures.features.paymentIntegration.title")}</h4>
                    <p className="text-slate-400">{t("platformFeatures.features.paymentIntegration.description")}</p>
                </div>
                <div className="flex flex-col gap-4">
                    <span className="material-symbols-outlined text-brand-gold text-4xl">public</span>
                    <p className="text-slate-400">{t("platformFeatures.features.performanceOptimization.description")}</p>
                </div>
            </div>
        </div>
    );
};

const BusinessSolution = () => {
    const { t } = useTranslation();

    const features = [
        {
            key: "integratedPlatform",
            image: featureIntegratedPlatform,
        },
        {
            key: "securePayments",
            image: featureSecurePayments,
        },
        {
            key: "robustArchitecture",
            image: featureRobustArchitecture,
        }
    ];

    return (
        <>
            <section className="py-24 relative z-10 w-full px-4 lg:px-0">
                <div className="container mx-auto">
                    <div className="flex flex-col gap-12 w-full">
                        <div className="flex flex-col gap-4 text-center items-center">
                            <h3 className="text-3xl md:text-5xl font-bold text-white">{t("businessSolution.title")}</h3>
                            <p className="text-slate-400 text-lg md:text-xl max-w-2xl">{t("businessSolution.subtitle")}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-16">
                        {features.map((feature, index) => (
                            <div key={index} className="flex flex-col bg-[#242322] border border-white/5 rounded-[24px] p-8 md:p-10 hover:bg-[#2a2928] hover:border-brand-gold/20 transition-all duration-300 group">
                                <div className="w-full flex justify-center mb-8 h-[200px] items-center">
                                    <img src={feature.image} alt={t(`businessSolution.features.${feature.key}.title`)} className="w-full max-h-[160px] object-contain floating-3d-icon group-hover:scale-110 transition-transform duration-500" />
                                </div>
                                <h6 className="text-2xl font-bold text-white mb-4">{t(`businessSolution.features.${feature.key}.title`)}</h6>
                                <p className="text-slate-400 leading-relaxed text-sm md:text-base">
                                    {t(`businessSolution.features.${feature.key}.description`)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

const QnASection = () => {
    const faqs = [
        {
            q: "What is the AANAND Wallet?",
            a: "AANAND Wallet is a secure, blockchain-based platform designed specifically for the global K-Pop fandom ecosystem, allowing fans to purchase tickets, merchandise, and interact with artists directly."
        },
        {
            q: "How does the AND token work?",
            a: "The AND token is our native ERC20 utility token. It powers instantaneous micro-transactions, rewards active community members, and facilitates secure payments across borders without high currency exchange fees."
        },
        {
            q: "Is my personal information secure?",
            a: "Yes. We utilize state-of-the-art blockchain technology and decentralized architecture to ensure all user data, transaction histories, and digital assets remain highly encrypted and secure against tampering."
        },
        {
            q: "How can I purchase AND tokens?",
            a: "You can easily swap your existing crypto (like ETH or USDT) for AND tokens directly through the Swap feature seamlessly integrated into the Aanand ecosystem interface."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);

    return (
        <section className="py-24 relative z-10 w-full px-4 lg:px-0 mt-12 overflow-hidden min-h-[600px] flex items-center">
            {/* Parallax Background Map with CSS Filter for Gold */}
            <div
                className="absolute top-0 left-0 w-full h-[150%] bg-center bg-no-repeat bg-fixed opacity-90 transition-transform duration-500"
                style={{
                    backgroundImage: 'url(/World-map-Animation.gif)',
                    backgroundSize: '45%',
                    filter: 'sepia(1) hue-rotate(-15deg) saturate(2) brightness(1.2) contrast(1.1)',
                    zIndex: 0
                }}
            ></div>
            {/* Overlay gradient to blend it into the void */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0904] via-[#0a0904]/80 to-[#0a0904] pointer-events-none z-10"></div>

            <div className="container mx-auto max-w-4xl relative z-20">
                <div className="flex flex-col gap-4 text-center items-center mb-16">
                    <h3 className="text-4xl md:text-5xl font-bold text-white tracking-wide">Frequently Asked Questions</h3>
                    <p className="text-brand-gold text-lg md:text-xl">Everything you need to know about the Aanand Ecosystem</p>
                </div>
                <div className="flex flex-col gap-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-[#1a1917]/80 backdrop-blur-md border border-brand-gold/10 rounded-2xl overflow-hidden transition-all duration-300 hover:border-brand-gold/30 gold-glow">
                            <button
                                className="w-full flex justify-between items-center p-6 text-left hover:bg-white/5 transition-colors"
                                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            >
                                <span className="text-lg font-bold text-white pr-4">{faq.q}</span>
                                <span className={`material-symbols-outlined text-brand-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}>
                                    expand_more
                                </span>
                            </button>
                            <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'}`}>
                                <div className="p-6 pt-0 text-slate-300 leading-relaxed">
                                    {faq.a}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};


const Home = () => {

    return (
        <div className="relative min-h-screen void-bg overflow-x-hidden">
            <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
                <div className="absolute top-[0%] left-[-10%] w-[40vw] h-[40vw] bg-brand-gold/10 rounded-full blur-[120px]"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-[40vw] h-[40vw] bg-brand-gold/5 rounded-full blur-[120px]"></div>
            </div>

            <div className="layout-container flex h-full grow flex-col relative z-10 w-full mx-auto">
                <NewHeader />
                <HomeBanner />
                <main className="container mx-auto flex-1 py-12 lg:py-20 relative z-10 px-6 lg:px-0">
                    <AboutToken />
                </main>
                <ProjectSection />
                <BusinessSolution />
                <PlatformFeatures />
                <QnASection />
                <ContactUs />
                <NewFooter />
            </div>
        </div>
    )
}

export default Home